export default __webpack_public_path__ + "static/media/Gym-Fitness.621d79cc.webp";